import React from 'react';

import { ContactSupportLink } from 'src/components/ContactSupportCTAs';

export const CheckEncounteredError = () => (
  <div className="mx-auto flex max-w-lg flex-1 items-center justify-center">
    <div>
      <div className="text-heading-xl mb-6 text-center">
        Unexpected error occurred
      </div>
      <div className="text-body mb-6 text-center">
        An unexpected error occurred when running this check. This could be
        because there were too many changes or affected operations.{' '}
        <ContactSupportLink>Contact support</ContactSupportLink> if you require
        any further assistance.
      </div>
    </div>
  </div>
);
